import script from "./ListadoDeOfertasHistoricasCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ListadoDeOfertasHistoricasCard.vue?vue&type=script&setup=true&lang=js"

import "./ListadoDeOfertasHistoricasCard.vue?vue&type=style&index=0&id=55f2223c&lang=scss"

const __exports__ = script;

export default __exports__